import { memo } from 'react'

const PriceDisplay = ({ price, period }) => {
  const formatted = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(price)

  const [whole, decimal = '00'] = formatted.split(',')
  const cleanWhole = whole.replace('R$', '').trim()

  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 2 }}>
      <span style={{ fontSize: 12, fontWeight: 500, color: 'rgba(255,255,255,0.45)', fontVariantNumeric: 'tabular-nums' }}>R$</span>
      <span style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em', color: '#fff', fontVariantNumeric: 'tabular-nums' }}>{cleanWhole}</span>
      <span style={{ fontSize: 12, fontWeight: 500, color: 'rgba(255,255,255,0.45)', fontVariantNumeric: 'tabular-nums' }}>,{decimal}</span>
      <span style={{ marginLeft: 2, fontSize: 11, fontWeight: 500, color: 'rgba(255,255,255,0.3)' }}>/{period}</span>
    </div>
  )
}

export default memo(PriceDisplay)
